/**
 * A Hacker News article carries no named brand (absent or the backend's
 * 'Unknown' placeholder) but does carry an integer `infoSourceId`. Single
 * source of truth for the check — it gates HN-specific rendering (title
 * suffix, analysis sheet variant) across the article analysis surfaces.
 */
export const isHackerNewsArticle = (article: {
  infoSourceId?: number | null;
  brand?: { brand?: string | null } | null;
}): boolean => {
  const hasNamedBrand =
    !!article.brand?.brand && article.brand.brand !== 'Unknown';
  return !hasNamedBrand && Number.isInteger(article.infoSourceId);
};
